import React, { PropsWithChildren, useCallback, useMemo } from 'react';
import { useAppDispatch } from '../../../../store';
import { closeStatisticsModal } from '../statisticsSlice';
import { Button, Row } from '@ydistri/ds';

const StatisticsModalTableFooter: React.FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useAppDispatch();
  const handleClose = useCallback(() => dispatch(closeStatisticsModal()), [dispatch]);

  const closeButton = useMemo(
    () => (
      <Button $colorVariant="outline" onClick={handleClose}>
        Close
      </Button>
    ),
    [handleClose],
  );

  return (
    <Row $gap="1rem" $flexGrow={1} $alignItems="center" $justifyContent="end">
      {children}
      {closeButton}
    </Row>
  );
};

export default StatisticsModalTableFooter;
